import type { Handleiding } from './soort';

export const en: Handleiding = {
  code: 'en',
  titel: 'Guide',
  inleiding:
    'Ask Gio Tolk interprets a conversation between two people who do not share a language. Here is what every button does.',
  knop: 'Open the guide',
  sluiten: 'Close',
  groepGebruik: 'Taking part',
  groepBeheer: 'Setting up and managing',
  delen: [
    {
      titel: 'Talking',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Speak',
          uitleg:
            'Tap once to start. The recording stops by itself once you have been quiet for just over a second, or when you tap again. After one minute it stops regardless.',
        },
        {
          kop: 'One sound at a time',
          uitleg:
            'While the app is speaking you cannot record. And while you are recording, an incoming translation waits until you are done. Otherwise your microphone records the app and it thinks you said that.',
        },
        {
          kop: 'Type your message here',
          uitleg:
            'Works alongside speaking and goes through the same translation. Enter sends, shift with enter starts a new line.',
        },
        {
          kop: 'Time to correct',
          uitleg:
            'Set how many seconds you get to read back your transcribed sentence before it goes out. At zero it goes immediately.',
        },
        {
          kop: 'Always check and send yourself',
          uitleg:
            'No more clock. Every sentence waits until you press send. For anyone who wants to check each line.',
        },
        {
          kop: 'Play the translation right away',
          uitleg:
            'On by default. Turn it off if you would rather read first and decide yourself when to listen.',
        },
      ],
    },
    {
      titel: 'Reading messages',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'What is shown large',
          uitleg:
            'Whatever is in YOUR language is shown large. For your own sentence that is your original text, so you can check whether the app heard you correctly. For the other person it is the translation.',
        },
        {
          kop: 'Unfolding the original or the translation',
          uitleg: 'The other language sits underneath, folded away. Tap the line to open it.',
        },
        {
          kop: 'The triangle',
          uitleg: 'Plays the translation again.',
        },
        {
          kop: 'The speaking head',
          uitleg:
            'Plays the other person’s own recording. It appears only on a SPOKEN message and only when "send your own voice as well" is on. A typed message has no recording.',
        },
      ],
    },
    {
      titel: 'Buttons at the top of the screen',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Minus and plus',
          uitleg: 'Makes the text smaller or larger. In five steps, and it is remembered.',
        },
        {
          kop: 'The microphone',
          uitleg: 'Hides the speak button if you are only typing anyway. That saves room.',
        },
        {
          kop: 'The keyboard',
          uitleg:
            'Hides the text box. One of the two always stays on, otherwise you could not say anything at all.',
        },
      ],
    },
    {
      titel: 'Joining',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Which language do you speak',
          uitleg:
            'This choice also sets the language of the buttons and the messages. So the two of you see different screens, and that is intentional.',
        },
        {
          kop: 'Your voice in the translation',
          uitleg:
            'Choose whether you sound male or female. This belongs to YOU, not to the room: both participants choose separately.',
        },
        {
          kop: 'Microphone permission',
          uitleg:
            'The browser asks for this as you enter. If you say no, you can still type. You can grant it later through the padlock in the address bar.',
        },
      ],
    },
    {
      titel: 'At the bottom, folded away',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Fallback word list',
          uitleg:
            'Words that must always be translated the same way: names, technical terms, brands. It applies to the whole room.',
        },
        {
          kop: 'Change settings',
          uitleg:
            'Language, voice, tone and spelling correction can be changed MID conversation. What you change here applies to both of you straight away.',
        },
      ],
    },
    {
      titel: 'Starting a conversation',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Name of the conversation',
          uitleg:
            'You may leave this empty. It only appears at the top of your screen, so you know who you are talking to.',
        },
        {
          kop: 'Speaker 1 and speaker 2',
          uitleg:
            'The two languages of this conversation. Whoever arrives first takes the first seat. You can still switch the languages later.',
        },
        {
          kop: 'Tone of the translation',
          uitleg:
            'On the left you pick the informal or the formal form of address, on the right the register: neutral, friendly, business, official or partner. Left to itself the model almost always picks the formal form, which sounds distant in an ordinary conversation.',
        },
        {
          kop: 'Send your own voice as well',
          uitleg:
            'Besides the translation, the other person can hear your own recording. Useful for learning a language. Turn this off for a sensitive conversation: whoever receives the recording can keep it.',
        },
        {
          kop: 'Correct spelling in your own text',
          uitleg:
            'On by default. Turn it off to see what the model actually understood. If a sentence then looks odd, you know whether it was misheard, or heard correctly and smoothed over afterwards.',
        },
        {
          kop: 'Add a PIN',
          uitleg:
            'Pass the code on by voice, not in the same message as the link. That protects you against a link being forwarded.',
        },
        {
          kop: 'The QR code',
          uitleg:
            'Let the other person scan it, or send the link. A room expires by itself after four hours.',
        },
      ],
    },
    {
      titel: 'What happens to your conversation',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'The text is not kept',
          uitleg:
            'What you say does not go into the database. Only when and how much was said, for the cost.',
        },
        {
          kop: 'Recordings disappear by themselves',
          uitleg: 'Audio stays in memory for ten minutes and is then gone.',
        },
        {
          kop: 'The room expires',
          uitleg: 'Four hours after it was created. After that the link no longer works.',
        },
        {
          kop: 'There is a budget',
          uitleg:
            'Per room and per month. If it runs out, the app stops translating and says so. That is not a fault.',
        },
      ],
    },
  ],
};
